module.exports = "../../../../platform/assets/pageMainIcon/business_yewushezhilei2.svg";